import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../../../lib/utils';
import { chartHatchBackground } from '../ensigns/chart-tone';
import { SpecraEyebrow } from '../ensigns/eyebrow';
import { specraFocusRing } from '../ensigns/focus-ring';
import { SpecraSwatch } from '../ensigns/swatch';
import { SpecraText } from '../ensigns/typography';
/** A 168×64 org seat: title, holder, origin. A button when it can be selected. */ export const SpecraOrgSeatCard = /*#__PURE__*/ React.forwardRef(({ seatTitle, holder, vacantLabel = 'Vacant', origin, since, joinedThisPeriod = false, selected = false, className, style, onClick, type: _type, ...props }, ref)=>{
    const interactive = Boolean(onClick);
    const name = `${seatTitle}: ${holder ?? vacantLabel}${origin ? `, ${origin.label}` : since ? `, ${since}` : ''}${joinedThisPeriod ? ', joined this period' : ''}`;
    const classes = cn('flex h-[var(--component-org-card-height)] w-[var(--component-org-card-width)] flex-col justify-center gap-[var(--space-0-5)] overflow-hidden rounded-[var(--radius-lg)] border border-[color:var(--border-control)] bg-[var(--surface-card)] px-[var(--space-2-5)] py-[var(--space-1-5)] text-left', interactive && 'cursor-pointer transition-colors hover:border-foreground/30', interactive && specraFocusRing, !holder && 'border-dashed', joinedThisPeriod && 'border-l-[length:var(--component-selected-rule-width)] border-l-success', selected && 'ring-2 ring-foreground', className);
    const mergedStyle = holder ? style : {
        ...style,
        backgroundImage: chartHatchBackground
    };
    const children = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(SpecraEyebrow, {
                className: "truncate",
                children: seatTitle
            }),
            /*#__PURE__*/ _jsx(SpecraText, {
                className: "truncate font-semibold",
                size: "body-sm",
                children: holder ?? vacantLabel
            }),
            holder ? /*#__PURE__*/ _jsxs(SpecraText, {
                className: "flex items-center gap-[var(--space-1)] truncate",
                size: "meta",
                tone: "muted",
                children: [
                    /*#__PURE__*/ _jsx(SpecraSwatch, {
                        shape: "square",
                        tone: origin?.tone ?? 'legacy'
                    }),
                    origin?.label ?? since
                ]
            }) : null
        ]
    });
    if (interactive) {
        return /*#__PURE__*/ _jsx("button", {
            "aria-label": name,
            "aria-pressed": selected,
            className: classes,
            "data-joined": joinedThisPeriod ? '' : undefined,
            onClick: onClick,
            ref: ref,
            style: mergedStyle,
            type: "button",
            ...props,
            children: children
        });
    }
    return(// biome-ignore lint/a11y/useSemanticElements: a read-only seat is a named group of text, not a form <fieldset>.
    /*#__PURE__*/ _jsx("div", {
        "aria-label": name,
        className: classes,
        "data-joined": joinedThisPeriod ? '' : undefined,
        "data-vacant": holder ? undefined : '',
        ref: ref,
        role: "group",
        style: mergedStyle,
        ...props,
        children: children
    }));
});
SpecraOrgSeatCard.displayName = 'SpecraOrgSeatCard';
